<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 text-sm text-gray-900">
      <div class="flex items-center space-x-3">
        <div v-if="hasSyncError" class="flex-none">
          <div ref="errorMessageTemplate" class="w-48" style="display: none">
            <strong v-if="!lastSyncErrorMessage">N/A</strong>
            <template v-else>
              <strong>{{ lastSyncErrorMessage }}</strong>
              <ul>
                <li v-for="(msg, msgIdx) in lastSyncErrorDetailMessages" :key="msgIdx">
                  {{ msg }}
                </li>
              </ul>
            </template>
          </div>
          <div
            class="p-2 bg-orange-200 rounded-full"
            v-tip="{
              content() {
                return errorMessage;
              },
              allowHTML: true,
            }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 block text-orange-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
        </div>
        <div class="flex-1">
          <p>{{ customer.name }}</p>
          <span class="text-xs text-gray-600">{{ customer.id }}</span>
        </div>
      </div>
    </td>
    <td class="px-4 py-4 text-sm text-gray-900 whitespace-nowrap">
      {{ customer.ga_campaigns_count }}
    </td>
    <td class="px-4 py-4 text-sm text-gray-900 whitespace-nowrap text-right">
      {{ lastSyncedAtFromNow }}
    </td>
  </tr>
</template>
<script>
import moment from 'moment';
import { isString } from 'lodash-es';

export default {
  props: {
    customer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    lastSyncedAt() {
      if (!this.customer.last_synced_at) {
        return null;
      }

      return moment.utc(this.customer.last_synced_at).local();
    },
    lastSyncedAtShort() {
      if (!this.lastSyncedAt) {
        return null;
      }

      return this.lastSyncedAt.format('DD-MM-YYYY');
    },
    lastSyncedAtFromNow() {
      if (!this.lastSyncedAt) {
        return '-';
      }

      return this.lastSyncedAt.fromNow();
    },
    hasSyncError() {
      return this.customer.last_sync_error !== null;
    },
    errorMessage() {
      const template = this.$refs.errorMessageTemplate;

      if (!template) {
        return 'Error message N/A';
      }

      const content = template.innerHTML || 'Error message N/A';

      return content;
    },
    lastSyncErrorMessage() {
      if (!this.hasSyncError) {
        return '';
      }

      return this.customer.last_sync_error?.message || 'Error message N/A';
    },
    lastSyncErrorDetailMessages() {
      if (!this.hasSyncError) {
        return [];
      }

      const { details = [] } = this.customer.last_sync_error;

      if (!Array.isArray(details)) {
        return [];
      }

      return details
        .reduce((carry, detail) => {
          if (!detail.errors || !Array.isArray(detail.errors)) {
            return carry;
          }

          return [...carry, ...detail.errors];
        }, [])
        .map((err) => {
          if (isString(err.message)) {
            return err.message;
          }

          return false;
        }, [])
        .filter(Boolean);
    },
  },
};
</script>
